/**
 * Created by Ning Jiang on 2021-05-18.
 */

export interface ISymbolsConfig {
    [symName:string]:{
        states:DeadwoodRipSymbolState[];
        reels?:number[]; // do we need this?
        highSymbol?:boolean; // For which layer this symbol will be added.
        isSpecial?:boolean; // For is the symbol can be used for fill up the reel randomly.
        stackedTotalNum?:number[] | number; // Can be same number for all reels, or different each reel.
    };
}

export enum DeadwoodRipSymbolState {
    NORMAL = "normal",
    SPIN = "spin",
    NO_WIN = "noWin",
    XRIP = "xRip"
}

export class DeadwoodRipSymbolConfig {

    public static SYMBOLS_DEFAULT_STATES:DeadwoodRipSymbolState[] = [
        DeadwoodRipSymbolState.NORMAL,
        DeadwoodRipSymbolState.SPIN,
        DeadwoodRipSymbolState.NO_WIN,
        DeadwoodRipSymbolState.XRIP
    ];

    public static SYMBOLS:ISymbolsConfig = {
        "C" : {
            states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [0],
            isSpecial : true,
            highSymbol : true
        },
        "L1" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L2" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L3" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L4" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L5" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "M1" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES, reels : [0, 1, 2, 3]},
        "M2" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES, reels : [0, 1, 2, 3]},
        "M3" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES, reels : [0, 1, 2, 3]},
        "M4" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES, reels : [0, 1, 2, 3]},
        "M5" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES, reels : [0, 1, 2, 3]},
        "WXN" : {
            states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [1, 2, 3],
            isSpecial : true,
            highSymbol : true,
            stackedTotalNum : 4
        },
        "S1" : {
            states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [1, 2, 3],
            isSpecial : true,
            highSymbol : true
        },
        "S3" : {
            states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [1, 3],
            isSpecial : true,
            highSymbol : true
        },
        "WRS" : {
            states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [1, 2, 3],
            isSpecial : true,
            highSymbol : true
        },
        "M1D" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES, reels : [4], stackedTotalNum : 2},
        "M2D" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES, reels : [4], stackedTotalNum : 2},
        "M3D" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES, reels : [4], stackedTotalNum : 2},
        "M4D" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES, reels : [4], stackedTotalNum : 2},
        "M5D" : {states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES, reels : [4], stackedTotalNum : 2},
        "S2" : {
            states : DeadwoodRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [4],
            isSpecial : true,
            highSymbol : true,
            stackedTotalNum : 2
        }
    };
}